import { Swiper, Navigation} from "swiper/bundle";
export default class Swipersocials {
    constructor() {
        console.log('%c👍🏼 Swiper socials', 'color: yellow');
        
        this.swipersocials = document.querySelectorAll('.swiper-socials')
    }
    init() {
        this.swipersocials.forEach((module, i) => {

            const elem = module.querySelector('.swiper--socials')
            const nextButton = module.querySelector('.swiper-button-next')
            const prevButton = module.querySelector('.swiper-button-prev')
           
            new Swiper(elem, {
                slidesPerView: 1.5,
                loop: false,
                spaceBetween: 40,
                speed: 1001,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    540: {
                    slidesPerView: 1.7
                    },

                    768: {
                        slidesPerView: 2.2,
                        spaceBetween: 60
                    },
                    998: {
                        slidesPerView: 3.8,
                        spaceBetween: 80

                    },
                }
            });   
        })
    }
}